import PlatformBadge from "components/PlatformBadge"
import type { PlatformBadge as PlatformBadgeData } from "data/platforms"

interface Props {
  badges: PlatformBadgeData[]
  /** Render badges as links (set false inside card anchors to avoid nested <a>). */
  interactive?: boolean
  className?: string
}

/** Renders one or more platform badges side by side (partner + infrastructure). */
const PlatformBadgeRow = ({ badges, interactive = true, className = "" }: Props) => {
  if (!badges.length) return null
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`.trim()}>
      {badges.map((badge) => (
        <PlatformBadge key={badge.id} badge={badge} interactive={interactive} />
      ))}
    </div>
  )
}

export default PlatformBadgeRow
